import { 
  Typography,
  Grid
} from "@mui/material";
import { TagRule, TagRuleCondition } from "models/events/TagRule";
import { useState, useEffect } from "react";
import { EditableTable, EditableGridColDef } from "components/alove/EditableTable";
import { EventParams } from "models/events/Event";
import { EventType } from "models/events/Event";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
interface TagConditionProps {
  tagRule: TagRule;
  onTagRuleChange: (tagRule: TagRule) => void;
}

export const TagCondition = ({ tagRule, onTagRuleChange }: TagConditionProps) => {
  const [localTagRule, setLocalTagRule] = useState<TagRule>(tagRule);

  useEffect(() => {
    setLocalTagRule(tagRule);
  }, [tagRule]);

  const handleFieldChange = (condition: TagRuleCondition[]) => {
    const updated = Object.assign(new TagRule(), { ...localTagRule, condition });
    setLocalTagRule(updated);
    onTagRuleChange(updated);
  };

  const processRowUpdate = async (newRow: TagRuleCondition, oldRow: TagRuleCondition) => {
    const updatedConditions = (localTagRule.condition || []).map(condition => 
      condition === oldRow ? newRow : condition
    );

    handleFieldChange(updatedConditions);
    return newRow;
  };

  const onAddRow = async (newCondition: TagRuleCondition) => {
    newCondition.id = `${newCondition.event}-${newCondition.count}-${newCondition.months}`;
    const updatedConditions = [...(localTagRule.condition || []), newCondition];
    handleFieldChange(updatedConditions);
  };

  const onDelRow = (conditionToDelete: TagRuleCondition) => {
    const updatedConditions = (localTagRule.condition || []).filter(
      condition => condition !== conditionToDelete
    );
    handleFieldChange(updatedConditions);
  };

  const columns: EditableGridColDef[] = [
    {
      field: "event",
      headerName: "Event",
      flex: 1,
      editable: true,
      customType: "autocomplete",
      getOptions: (row) => {
        return Object.values(EventType).map(event => ({
          value: event,
          label: camelCaseToCapitalizedWords(event)
        }));
      },
    },
    {
      field: "param1",
      headerName: "Param 1",
      flex: 1,
      editable: true,
      multiple: true,
      customType: "autocomplete",
      getOptions: (row) => {
        return EventParams[row.event as EventType] || [];
      },
    },
    {
      field: "count",
      headerName: "Count",
      flex: 1,
      editable: true,
      type: "number",
    },
    {
      field: "months",
      headerName: "Months",
      flex: 1,
      editable: true,
      type: "number",
    }
  ];

  return (
        <EditableTable
          rows={localTagRule.condition || []}
          columns={columns}
          processRowUpdate={processRowUpdate}
          onAddRow={onAddRow}
          onDelRow={onDelRow}
          modelName="Condition"
          getRowId={(row) => `${row.event}-${row.count}-${row.months}`}
            />
  );
}; 